// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3A17oj","quantityAndVariantWrap":"_2E7TMK","variantWrapper":"_2efWpq"};